import { ICreatedRecordParameters, IModifiedRecordParameters } from "../../../../api/GenericTypes";
import {
  EnteredRecordEntityDefaultFilterFormValues,
  enteredRecordEntityFiltersToForm,
  enteredRecordEntityFormToFilters,
  IEnteredRecordEntityForm,
} from "./EnteredRecordEntityFilterFormModels";
import {
  IModificationRecordEntityForm,
  ModificationRecordEntityDefaultFilterFormValues,
  modificationRecordEntityFiltersToForm,
  modificationRecordEntityFormToFilters,
} from "./ModificationRecordEntityFilterFormModels";

export interface ICombinedModificationRecordEntityForm
  extends IEnteredRecordEntityForm,
    IModificationRecordEntityForm {}

export const CombinedModificationRecordEntityDefaultFormValues: Required<ICombinedModificationRecordEntityForm> = {
  ...EnteredRecordEntityDefaultFilterFormValues,
  ...ModificationRecordEntityDefaultFilterFormValues,
};

export const combinedModificationRecordEntityFormToFilters = <
  Filters extends Partial<ICreatedRecordParameters & IModifiedRecordParameters>
>(
  form: ICombinedModificationRecordEntityForm
): Filters => {
  let filters = {
    ...enteredRecordEntityFormToFilters(form),
    ...modificationRecordEntityFormToFilters(form),
  } as Filters;
  return filters;
};

export const combinedModificationRecordEntityFiltersToForm = (
  filters: Partial<ICreatedRecordParameters & IModifiedRecordParameters>
): ICombinedModificationRecordEntityForm => {
  return {
    ...enteredRecordEntityFiltersToForm(filters),
    ...modificationRecordEntityFiltersToForm(filters),
  };
};
